/* eslint-disable @typescript-eslint/no-unused-expressions */
import {useCallback, useEffect, useState} from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import {Form, Button, Tabs, Tab} from 'react-bootstrap'
import {useAuth} from '../../../auth'
import {v4 as uuid} from 'uuid'
import axios from 'axios'
import {BASE_URL} from '../../../config'
import {Route} from '../../core/_model'
import {useSenderIdProvider} from '../../context/SenderIdProvider'
import ContentLoading from '../../../../utils/components/Loading/ContentLoading'
import {
  ICheckboxValues,
  IOperatorNumbers,
  ISelectValues,
  ITextValues,
  operator,
  statusOptions,
} from '../_model'
import {useUserStateProvider} from '../../../../utils/contextProvider/UserStateProvider'

const GET_SINGLE_MASKING_SENDER = `${BASE_URL}/api/protect/getSender`

const SenderIdMaskingModal = () => {
  const {auth} = useAuth()
  const {
    options,
    updateSender: updateSenderId,
    hide,
    createMaskingSender,
    createNonMaskingSender,
    updateNonBranded,
    updateBranded,
  } = useSenderIdProvider()
  const {isGlobalP2p} = useUserStateProvider()

  const [key, setKey] = useState('nonmasking')
  const [selectRoute, setSelectRoute] = useState<string | undefined>('')
  const [nonMaskingSender, setNonMaskingSender] = useState('')
  const [maskingSender, setMaskingSender] = useState('')
  const [loading, setLoading] = useState(false)
  const [senderStatus, setSenderStatus] = useState<string | undefined>(undefined)
  const [senderType, setSenderType] = useState('0')

  const [checkboxValues, setCheckboxValues] = useState<ICheckboxValues>({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    checkbox4: false,
    checkbox5: false,
    checkbox6: false,
    checkbox7: false,
  })

  const [operatorNumbers] = useState<IOperatorNumbers>({
    operatorNumber1: '88013',
    operatorNumber2: '88014',
    operatorNumber3: '88015',
    operatorNumber4: '88016',
    operatorNumber5: '88017',
    operatorNumber6: '88018',
    operatorNumber7: '88019',
  })

  const [selectValues, setSelectValues] = useState<ISelectValues>({
    select1: 'Option 1',
    select2: 'Option 1',
    select3: 'Option 1',
    select4: 'Option 1',
    select5: 'Option 1',
    select6: 'Option 1',
    select7: 'Option 1',
  })

  const [textValues, setTextValues] = useState<ITextValues>({
    text1: '',
    text2: '',
    text3: '',
    text4: '',
    text5: '',
    text6: '',
    text7: '',
  })

  const resetForm = () => {
    setKey('nonmasking')
    setSelectRoute('')
    setNonMaskingSender('')
    setMaskingSender('')
    setLoading(false)
    setSenderStatus(undefined)
    setSenderType('')

    setCheckboxValues({
      checkbox1: false,
      checkbox2: false,
      checkbox3: false,
      checkbox4: false,
      checkbox5: false,
      checkbox6: false,
      checkbox7: false,
    })

    setSelectValues({
      select1: 'Option 1',
      select2: 'Option 1',
      select3: 'Option 1',
      select4: 'Option 1',
      select5: 'Option 1',
      select6: 'Option 1',
      select7: 'Option 1',
    })

    setTextValues({
      text1: '',
      text2: '',
      text3: '',
      text4: '',
      text5: '',
      text6: '',
      text7: '',
    })
  }

  const handleTextChange = useCallback(
    (prefix: string, value: string) => {
      setTextValues((prevValues) => ({
        ...prevValues,
        [prefix]: value,
      }))
    },
    [setTextValues]
  )

  const handleCheckboxChange = (prefix: string) => {
    setCheckboxValues((prevValues) => {
      const updatedValues = {
        ...prevValues,
        [prefix]: !prevValues[prefix],
      }
      const range = prefix.charAt(prefix.length - 1)
      if (updatedValues[prefix]) {
        setTextValues((prevValues) => ({
          ...prevValues,
          [`text${range}`]: maskingSender,
        }))
      } else {
        setTextValues((prevValues) => ({
          ...prevValues,
          [`text${range}`]: '',
        }))
      }
      return updatedValues
    })
  }

  const handleSelectChange = (prefix: string, value: string) => {
    setSelectValues((prevValues) => ({
      ...prevValues,
      [prefix]: value,
    }))
  }

  const getCheckedValues = () => {
    const checkedValues = []
    for (let number = 1; number <= operator.length; number++) {
      const prefix = `checkbox${number}`
      if (checkboxValues[prefix]) {
        const isRoute: any = options.find(
          (opt: Route) => opt.name === selectValues[`select${number}`]
        )
        const value = {
          operatorPrefix: operatorNumbers[`operatorNumber${number}`],
          // routeconfId: selectValues[`select${number}`],
          routeconfId: isRoute ? isRoute.id : '',
          masking: textValues[`text${number}`],
        }
        checkedValues.push(value)
      }
    }
    return checkedValues
  }

  const getSingleMaskingSender = async (id: number) => {
    try {
      setLoading(true)
      const response = await axios.get(`${GET_SINGLE_MASKING_SENDER}/${id}?senderId=${id}`, {
        headers: {Authorization: `Bearer ${auth?.accessToken}`},
      })
      const {senderInfoDto, maskingDetailsDto} = await response.data
      // console.log(maskingDetailsDto)
      setMaskingSender(senderInfoDto.sender)

      Object.entries(operatorNumbers).forEach((itemOperator, indexOperator) => {
        // console.log(itemOperator)
        maskingDetailsDto.forEach((itemMaskDetails: any) => {
          console.log(itemMaskDetails.senderrouteid)
          if (itemOperator[1] === itemMaskDetails.operatorprefix) {
            // console.log(indexOperator)
            const prefixNum = indexOperator + 1
            setCheckboxValues((prevValues) => ({
              ...prevValues,
              [`checkbox${prefixNum}`]: true,
            }))

            setTextValues((prevValues) => ({
              ...prevValues,
              [`text${prefixNum}`]: itemMaskDetails.masking,
            }))

            const route = options.find((opt: Route) => opt.id === itemMaskDetails.routeconfId)

            setSelectValues((prevValues) => ({
              ...prevValues,
              [`select${prefixNum}`]: route?.name,
            }))
          }
        })
      })

      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    if (updateSenderId) {
      setNonMaskingSender('')
      setSelectRoute('')
      setMaskingSender('')
      setSenderStatus(updateSenderId.senderStatus === '1' ? 'Active' : 'Inactive')
      setSenderType(String((updateSenderId as any)?.branded ?? ''))
      setCheckboxValues({
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
        checkbox4: false,
        checkbox5: false,
        checkbox6: false,
        checkbox7: false,
      })
      setTextValues({
        text1: '',
        text2: '',
        text3: '',
        text4: '',
        text5: '',
        text6: '',
        text7: '',
      })
      setSelectValues({
        select1: 'Option 1',
        select2: 'Option 1',
        select3: 'Option 1',
        select4: 'Option 1',
        select5: 'Option 1',
        select6: 'Option 1',
        select7: 'Option 1',
      })
      if (updateSenderId.branded === 0 || updateSenderId.branded === 2) {
        setKey('nonmasking')
        setNonMaskingSender(updateSenderId.sender)
        const route = options.find((opt: Route) => opt.id === updateSenderId.routeconfid)
        setSelectRoute(route?.name)
      } else {
        setKey('masking')
        getSingleMaskingSender(updateSenderId.id)
      }
    } else {
      setNonMaskingSender('')
      setSelectRoute('')
      setMaskingSender('')
      setSenderType('0')
      setCheckboxValues({
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
        checkbox4: false,
        checkbox5: false,
        checkbox6: false,
        checkbox7: false,
      })
      setTextValues({
        text1: '',
        text2: '',
        text3: '',
        text4: '',
        text5: '',
        text6: '',
        text7: '',
      })
      setSelectValues({
        select1: 'Option 1',
        select2: 'Option 1',
        select3: 'Option 1',
        select4: 'Option 1',
        select5: 'Option 1',
        select6: 'Option 1',
        select7: 'Option 1',
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateSenderId])

  const handleMasking = async (e: any) => {
    e.preventDefault()
    // console.log(maskingSenderName.current.value)
    if (!maskingSender) {
      return
    }
    const data = {
      senderId: maskingSender,
      senderStatus: senderStatus === 'Active' ? '1' : '0',
      maskingInfo: getCheckedValues(),
    }

    if (updateSenderId) {
      await updateBranded(updateSenderId.id, data)
      resetForm()
    } else {
      await createMaskingSender(data)
      resetForm()
    }
  }

  const handleNonMasking = async (e: any) => {
    e.preventDefault()
    const isRoute: any = options.find((opt: Route) => opt.name === selectRoute)

    if (isRoute) {
      const data = {
        senderId: nonMaskingSender,
        senderStatus: senderStatus === 'Active' ? '1' : '0',
        routeId: isRoute.id,
        ...(senderType && {isP2p: Number(senderType)}),
      }
      if (updateSenderId) {
        await updateNonBranded(updateSenderId.id, data)
        resetForm()
      } else {
        await createNonMaskingSender(data)
        resetForm()
      }
    } else {
      return
    }
  }

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
      <div className='modal-dialog modal-dialog-centered modal-lg'>
        <div className='modal-content py-2'>
          <div className='modal-header border-0'>
            <h4 className='modal-title fs-1'>Sender ID's</h4>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={() => hide()}
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
            {/* <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={() => hide()}
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div> */}
          </div>

          {loading ? (
            <ContentLoading />
          ) : (
            <Tabs
              activeKey={key}
              onSelect={(k: any) => setKey(k)}
              id='controlled-tab'
              className='mb-3'
            >
              {/* <Tab
                eventKey='masking'
                className='px-15 pb-10'
                title='Masking'
                disabled={updateSenderId ? (key === 'nonmasking' ? true : false) : false}
              >
                <form onSubmit={handleMasking}>
                  <div className='mb-4'>
                    <label className='col-lg-4 col-form-label fs-6'>
                      <span>Sender Name</span>
                    </label>

                    <div className='col-lg-12 fv-row'>
                      <input
                        // name='cm_name'
                        // ref={maskingSenderName}
                        value={maskingSender}
                        onChange={(e) => setMaskingSender(e.target.value)}
                        placeholder='Sender Name'
                        className='form-control form-control-lg form-control custom-input'
                      />
                    </div>
                  </div>

                  <div className='mb-4'>
                    <label className='col-lg-4 col-form-label fs-6'>
                      <span>Status</span>
                    </label>

                    <div className='col-lg-12 fv-row'>
                      <Select
                        className='react-select-styled custom-input'
                        classNamePrefix='react-select'
                        options={statusOptions}
                        placeholder='Select an option'
                        onChange={(selectedOption) => {
                          setSenderStatus(selectedOption?.id)
                        }}
                      />
                    </div>

                    <Form.Select
                      value={senderStatus}
                      onChange={(e) => {
                        e.persist()
                        setSenderStatus(e.target.value)
                      }}
                      placeholder='Select status'
                      className='custom-input'
                    >
                      <option>Select status</option>
                      {statusOptions &&
                        statusOptions.map((option) => {
                          return (
                            <option key={uuid()} value={option.value}>
                              {option.label}
                            </option>
                          )
                        })}
                    </Form.Select>
                  </div>

                  <div className='mb-4'>
                    <label className='col-lg-4 col-form-label  fs-6'>
                      <span>Select operator</span>
                    </label>
                    {operator.map((number) => {
                      return (
                        <div className='d-flex align-items-center mb-6 gap-3' key={number}>
                          <div className='form-check'>
                            <input
                              className='form-check-input custom-input'
                              type='checkbox'
                              checked={checkboxValues[`checkbox${number}`]}
                              onChange={(e) => {
                                e.persist()
                                handleCheckboxChange(`checkbox${number}`)
                              }}
                            />
                            <label className='form-check-label text-gray-700'>
                              {operatorNumbers[`operatorNumber${number}`]}
                            </label>
                          </div>
                          <Form.Select
                            value={selectValues[`select${number}`]}
                            onChange={(e) => {
                              e.persist()
                              handleSelectChange(`select${number}`, e.target.value)
                            }}
                            placeholder='Select a route'
                            className='custom-input'
                          >
                            <option>Select a route</option>
                            {options &&
                              options.map((option: any) => {
                                return (
                                  <option key={uuid()} value={option.name}>
                                    {option.name}
                                  </option>
                                )
                              })}
                          </Form.Select>
                          <div className='col-lg-6'>
                            <input
                              type='text'
                              value={textValues[`text${number}`]}
                              onChange={(e) => {
                                e.persist()
                                handleTextChange(`text${number}`, e.target.value)
                              }}
                              placeholder={`Branded name ${
                                operatorNumbers[`operatorNumber${number}`]
                              } prefix`}
                              className='form-control form-control-lg form-control custom-input'
                            />
                          </div>
                        </div>
                      )
                    })}
                  </div>
                  <div>
                    <Button
                      type='submit'
                      variant='primary'
                      size='lg'
                      className='d-block mt-8 w-100'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                    >
                      {updateSenderId ? 'Update' : 'Save'}
                    </Button>
                  </div>
                </form>
              </Tab> */}

              <Tab
                eventKey='nonmasking'
                title=''
                className='px-15 pb-10'
                disabled={updateSenderId ? (key === 'masking' ? true : false) : false}
              >
                <form onSubmit={handleNonMasking}>
                  <div className='mb-4'>
                    <label className='col-lg-4 col-form-label  fs-6'>
                      <span className='required fs-4'>Sender Name</span>
                    </label>

                    <div className='col-lg-12 fv-row'>
                      <input
                        name='cm_name'
                        placeholder='Sender Name'
                        value={nonMaskingSender}
                        onChange={(e) => setNonMaskingSender(e.target.value)}
                        className='form-control form-control-lg form-control custom-input'
                        required
                      />
                    </div>
                  </div>

                  <div className='mb-4'>
                    <label className='col-lg-4 col-form-label fs-6'>
                      <span>Status</span>
                    </label>

                    <Form.Select
                      value={senderStatus}
                      onChange={(e) => {
                        e.persist()
                        setSenderStatus(e.target.value)
                      }}
                      placeholder='Select status'
                      className='custom-input'
                    >
                      <option>Select status</option>
                      {statusOptions &&
                        statusOptions.map((option) => {
                          return (
                            <option key={uuid()} value={option.value}>
                              {option.label}
                            </option>
                          )
                        })}
                    </Form.Select>
                  </div>

                  <label className='col-lg-4 col-form-label  fs-6'>
                    <span className='required fs-4'>Route</span>
                  </label>
                  <Form.Select
                    value={selectRoute}
                    onChange={(e) => setSelectRoute(e.target.value)}
                    placeholder='Select a route'
                    className='custom-input'
                    required
                  >
                    <option>Select a route</option>
                    {options &&
                      options.map((option: any) => {
                        return (
                          <option key={option.id} value={option.name}>
                            {option.name}
                          </option>
                        )
                      })}
                  </Form.Select>
                  <span className='fs-6'>Which route will be used to send the message</span>

                  {isGlobalP2p && !updateSenderId && (
                    <div>
                      <label className='col-lg-4 col-form-label  fs-6'>
                        <span className='required fs-4'>Sender Type</span>
                      </label>
                      <Form.Select
                        value={senderType}
                        onChange={(e) => setSenderType(e.target.value)}
                        placeholder='Select type'
                        className='custom-input'
                        required
                      >
                        <option value=''>Select type</option>
                        <option value='2'>P2P</option>
                        <option value='0'>A2P</option>
                      </Form.Select>
                    </div>
                  )}

                  <div>
                    <Button
                      type='submit'
                      variant='primary'
                      size='lg'
                      className='d-block mt-8 w-100'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                    >
                      {updateSenderId ? 'Update' : 'Save'}
                    </Button>
                  </div>
                </form>
              </Tab>
            </Tabs>
          )}
        </div>
      </div>
    </div>
  )
}

export default SenderIdMaskingModal
